import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';


i18n
  .use(initReactI18next)
  .init({
    resources: {
      ko_KR: {
        translation: require('./locales/ko-KR.json'),
      },
      en_US: {
        translation: require('./locales/en-US.json'),
      },
      // 다른 언어 리소스 추가 가능
    },
    lng: 'ko_KR', // 기본 언어를 ko-KR로 설정
    fallbackLng: 'en_US', // 기본 언어가 없을 때 사용할 대체 언어
    interpolation: {
      escapeValue: false, // React에서 XSS 공격 방지
    },
  });

export default i18n;
